/**
 * Lord of Venues platform FSSAI license number.
 * Required by Indian law to be displayed alongside vendor FSSAI on all food menus.
 */
export const LOV_FSSAI_LICENSE = '11526999000479';
